





import { Vue, Component, Prop } from "vue-property-decorator";

/**
 * A table colum for the *anx-table*
 */
@Component({})
export default class AnxTableCol extends Vue {
  /** The content for the column */
  @Prop({ default: "" }) content!: string;

  /** The align for the content in the column [left, center, right] */
  @Prop({ default: "left" }) align!: string;
}
